import { render } from "./filter-s10.vue?vue&type=template&id=1b4e457e"
import script from "./filter-s10.vue?vue&type=script&lang=js"
export * from "./filter-s10.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__